<template>
  <el-form
    ref="ruleForm"
    :model="formData"
    :rules="ruleData"
    class="content-file-form"
    :label-width="width"
    :label-position="position"
    :class="className"
    :style="cssStyle"
  >
    <el-form-item
      v-for="(item, index) in formList"
      :key="index"
      :label="item.label"
      :prop="item.prop"
      :class="item.className"
    >
      <div v-if="item.divType">{{ getValue(formData, item.prop) }}</div>
      <div v-else-if="item.flowFilter">
        {{ getValue(formData, item.prop) | flowFilter }}
      </div>
      <div v-else-if="item.htmlType">
        <span
          v-if="formData[item.prop]"
          v-html="renderHighlight(formData[item.prop])"
        >
        </span>
        <span v-else>-</span>
      </div>
      <div v-else-if="item.component">
        <component
          :is="item.component"
          :row="formData"
          :cusprop="item.cusprop"
          :keywordArr="keywordArr"
        />
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "PublicForm",
  props: {
    formList: {
      type: Array,
      default() {
        return [];
      },
    },
    ruleData: {},
    width: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    cssStyle: {
      type: String,
      default: "",
    },
    formData: {
      type: Object,
      default() {
        return {};
      },
    },
    keywordArr: {
      type: Array,
      default() {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    renderHighlight() {
      return function (prop) {
        let returnV = this.$options.filters.renderHighlight(
          prop,
          this.keywordArr
        );
        return returnV;
      };
    },
  },
  methods: {
    getValue(row, prop) {
      if (!prop) return "-";
      if (prop.indexOf(".") > -1) {
        return this.$jsonPath(row, prop) ? this.$jsonPath(row, prop) : "-";
      }
      if (row[prop] === "" || row[prop] === null || row[prop] === undefined) {
        return "-";
      }
      return row[prop];
    },
  },
};
</script>
